import photonDark from "./assets/photon-dark.png";
import photonLight from "./assets/photon-light.png";

const logotext = "LS";
const meta = {
    title: "Leonard Schue",
    description: "I’m Leonard Schue, a researcher in physics optics, currently working at the Polytechnic",
};

const introdata = {
    title: "I’m Leonard Schue",
    animated: {
        first: "Delving into the mysteries of optics",
        second: "Pioneering research in photonic systems",
        third: "Exploring light-matter interactions",
    },
    description: "Engaged in advanced research in the field of optics, with a focus on innovative photonic technologies and light manipulation techniques.",
    dark_img_url: photonDark,
    light_img_url: photonLight
};

const dataabout = {
    title: "A bit about myself",
    aboutme: "With a strong foundation in physics and a passion for optical phenomena, my work centers on exploring and developing cutting-edge optical systems. My journey in the world of optics has been marked by significant research contributions and collaborations with renowned experts in the field.",
};

const worktimeline = [
    // Update with relevant work experience in physics optics
    {
        jobtitle: "Optics Research Fellow",
        where: "Institute of Photonics, Polytechnic",
        date: "2023",
    },
    // Add more entries as needed
];

const skills = [
    // Update skills relevant to physics optics
    {
        name: "Optical Simulation",
        value: 95,
    },
    {
        name: "Experimental Physics",
        value: 90,
    },
    {
        name: "Data Analysis",
        value: 85,
    },
    // Add more skills as needed
];

const services = [
    // Update services to reflect research expertise
    {
        title: "Optical System Design",
        description: "Designing and simulating advanced optical systems for various applications in research and industry.",
    },
    {
        title: "Photonic Research",
        description: "Conducting groundbreaking research in photonics, focusing on light-matter interactions and photonic technologies.",
    },
    // Add more services as relevant
];

const dataportfolio = [
    // Update with relevant research projects or publications
    {
        "img": "https://images.unsplash.com/photo-1669460282593-86c66d00e346?q=80&w=1480&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "description": "Arising of a bulk plasmon in the optical response of a WS 2 monolayer",
        "link": "https://hal.science/hal-05371681v1/file/Andriambelaza_et_al_Article.pdf"
    },
    {
        "img": "https://images.unsplash.com/photo-1765256931541-fc958b88de83?q=80&w=2072&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "description": "Tunable electronic band structure in WSSe van der Waals Alloys",
        "link": "https://arxiv.org/pdf/2511.11146"
    },
    {
        "img": "https://images.unsplash.com/photo-1723909776959-7b0cc2fc94f2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "description": "Tunable electronic band structure in WS 2 (1-x) Se 2x van der Waals Alloys",
        "link": "https://hal.science/hal-05371725v1/file/Bouaziz_et_al_accepted_PRB_10_11_2025.pdf"
    },
    {
        "img": "https://images.unsplash.com/photo-1596226310268-f76b50d14a4a?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGNyeXN0YWx8ZW58MHx8MHx8fDA%3D",
        "description": "Crystal field tuned spin-flip luminescence in NiPS3",
        "link": "https://scholar.google.com/citations?view_op=view_citation&hl=fr&user=Mqe9TNcAAAAJ&sortby=pubdate&citation_for_view=Mqe9TNcAAAAJ:L8Ckcad2t8MC"
    },
    {
        "img": "https://images.unsplash.com/photo-1710292036904-3dc60dd14e53?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fHNwZWN0cmV8ZW58MHx8MHx8fDI%3D",
        "description": "Distinguishing different stackings in layered materials via luminescence spectroscopy",
        "link": "https://journals.aps.org/prl/abstract/10.1103/PhysRevLett.131.206902"
    },
    {
        "img": "https://images.unsplash.com/photo-1675044794037-9262cedb6d5d?q=80&w=3132&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "description": "Graphene Episulfide: Covalent Sulfur Addition to Graphene Surfaces",
        "link": "https://www.researchsquare.com/article/rs-3562763/v1"
    },
    {
        "img": "https://images.unsplash.com/photo-1699819011236-77b5cbf47f1c?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTN8fEVsZW1lbnRhbCUyMFN1bGZ1ciUyMGF0JTIwdGhlJTIwU3VyZmFjZXMlMjBvZiUyMENhcmJvbiUyME5hbm90dWJlcyUyMGFuZCUyMEdyYXBoZW5lfGVufDB8fDB8fHwy",
        "description": "Reaction of Elemental Sulfur at the Surfaces of Carbon Nanotubes and Graphene",
        "link": "https://iopscience.iop.org/article/10.1149/MA2023-01101207mtgabs/meta"
    },
    {
        "img": "https://images.unsplash.com/photo-1666037801539-f30fd661657a?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fG1pY3JvZWxlY3Ryb25pY3N8ZW58MHx8MHx8fDI%3D",
        "description": "Electronic and Vibrational Properties of Episulfide-Graphene Materials",
        "link": "https://iopscience.iop.org/article/10.1149/MA2023-01131320mtgabs/meta"
    },
    {
        "img": "https://images.unsplash.com/photo-1545486332-9e0999c535b2?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fE91dCUyMG9mJTIwUGxhbmUlMjBCbGFjayUyMFBob3NwaG9ydXN8ZW58MHx8MHx8fDI%3D",
        "description": "Out-of-Plane Polarized Visible Luminescence and Electronic Resonance in Black Phosphorus",
        "link": "https://iopscience.iop.org/article/10.1149/MA2022-0112852mtgabs/meta"
    },
    {
        "img": "https://images.unsplash.com/photo-1663517768994-a65e6ab3a40a?q=80&w=2160&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "description": "Raman Study of a New Black Phosphorus Degradation Product",
        "link": "https://ecs.confex.com/ecs/241/meetingapp.cgi/Paper/159120"
    },
    {
        "img": "https://images.unsplash.com/photo-1658758212601-bf600d83f0f2?q=80&w=3134&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "description": "New Degradation By-Products of Few Layers Black Phosphorus",
        "link": "https://ecs.confex.com/ecs/241/meetingapp.cgi/Paper/157297"
    },
    {
        "img": "https://images.unsplash.com/photo-1608562719218-920013a7a249?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8bHVtaW5lc2NlbmNlfGVufDB8fDB8fHwy",
        "description": "Visible out-of-plane polarized luminescence and electronic resonance in black phosphorus",
        "link": "https://pubs.acs.org/doi/abs/10.1021/acs.nanolett.1c04998"
    },
    {
        "img": "https://images.unsplash.com/photo-1621866546422-4b9edfbdab51?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cG9sYXJpemVkJTIwb3B0aWNhbCUyMHJlc3BvbnNlc3xlbnwwfHwwfHx8Mg%3D%3D",
        "description": "Highly polarized optical responses in bulk black phosphorus from high energy states",
        "link": "https://ui.adsabs.harvard.edu/abs/2022APS..MARB55012S/abstract"
    },
    {
        "img": "https://images.unsplash.com/photo-1576916385844-befd8945138c?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bGFzZXJ8ZW58MHx8MHx8fDI%3D",
        "description": "How high is a MoSe2 monolayer?",
        "link": "https://iopscience.iop.org/article/10.1088/1361-6528/ac40bd/meta"
    },
    {
        "img": "https://images.unsplash.com/photo-1626362073981-75205f952cf3?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8bWV0YWx8ZW58MHx8MHx8fDI%3D",
        "description": "Heteroepitaxial growth of sp2-hybridized boron nitride multilayer on nickel substrates by CVD: the key role of the substrate orientation",
        "link": "https://iopscience.iop.org/article/10.1088/2053-1583/aba8ad/meta"
    },
    {
        "img": "https://images.unsplash.com/photo-1650462615776-75266780c597?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGZsdW9yZXNjZW5jZXxlbnwwfHwwfHx8Mg%3D%3D",
        "description": "Confinement of dyes inside boron nitride nanotubes: photostable and shifted fluorescence down to the near infrared",
        "link": "https://advanced.onlinelibrary.wiley.com/doi/abs/10.1002/adma.202001429"
    },
    {
        "img": "https://images.unsplash.com/photo-1534744971734-e1628d37ea01?q=80&w=3174&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "description": "Plasma Thinning of Large Black Phosphorus Flakes",
        "link": "https://iopscience.iop.org/article/10.1149/MA2020-0110820mtgabs/meta"
    },
    {
        "img": "https://images.unsplash.com/photo-1637186209526-652da1746ff4?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Z3JhcGhlbmV8ZW58MHx8MHx8fDI%3D",
        "description": "Production and processing of graphene and related materials",
        "link": "https://iopscience.iop.org/article/10.1088/2053-1583/ab1e0a/meta"
    },
    {
        "img": "https://images.unsplash.com/photo-1556691421-cf15fe27a0b6?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "description": "Spectral responsivity and photoconductive gain in thin film black phosphorus photodetectors",
        "link": "https://pubs.acs.org/doi/abs/10.1021/acsphotonics.9b00951"
    }
    // Add more entries as needed
];

const contactConfig = {
    YOUR_EMAIL: "leonard.schue@polytechnique.edu",
    YOUR_FONE: "(33)0612345678",
    description: "For inquiries about my research or potential collaborations, please feel free to reach out via email.",
    // // Update with your EmailJS configuration
    // YOUR_SERVICE_ID: "your_service_id",
    // YOUR_TEMPLATE_ID: "your_template_id",
    // YOUR_USER_ID: "your_user_id",
};

const socialprofils = {
    googlescholar: "https://scholar.google.com/citations?view_op=list_works&hl=fr&hl=fr&user=Mqe9TNcAAAAJ&sortby=pubdate",
    linkedin: "https://www.linkedin.com/in/l%C3%A9onard-schu%C3%A9-15416932b",
    twitter: "https://twitter.com/SchueLeonard",
};

export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};